import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { LayoutDashboard, Wrench, Users, Car, Package, CircleDollarSign, Calendar, Settings, LogOut } from 'lucide-react';
const navigation = [{
  name: 'Dashboard',
  href: '/app',
  icon: LayoutDashboard
}, {
  name: 'Ordens de Serviço',
  href: '/app/ordens',
  icon: Wrench
}, {
  name: 'Clientes',
  href: '/app/clientes',
  icon: Users
}, {
  name: 'Veículos',
  href: '/app/veiculos',
  icon: Car
}, {
  name: 'Estoque',
  href: '/app/estoque',
  icon: Package
}, {
  name: 'Financeiro',
  href: '/app/financeiro',
  icon: CircleDollarSign
}, {
  name: 'Agenda',
  href: '/app/agenda',
  icon: Calendar
}];
export function Sidebar({
  onNavigate
}: {
  onNavigate?: () => void;
}) {
  const location = useLocation();
  return <div className="flex h-full w-full flex-col border-r border-border bg-sidebar" data-id="element-228">
      <div className="flex h-16 shrink-0 items-center px-6 border-b border-border" data-id="element-229">
        <Link to="/app" className="flex items-center gap-2" onClick={onNavigate} data-id="element-230">
          <div className="bg-primary p-1.5 rounded-lg" data-id="element-231">
            <Wrench className="h-5 w-5 text-primary-foreground" data-id="element-232" />
          </div>
          <span className="font-heading font-bold text-lg tracking-tight" data-id="element-233">
            GarageFlow
          </span>
        </Link>
      </div>

      <div className="flex flex-1 flex-col overflow-y-auto px-4 py-6" data-id="element-234">
        <nav className="flex-1 space-y-1" data-id="element-235">
          {navigation.map(item => {
          const isActive = location.pathname === item.href || item.href !== '/app' && location.pathname.startsWith(item.href);
          return <Link key={item.name} to={item.href} onClick={onNavigate} className={cn(isActive ? 'bg-primary/10 text-primary font-medium' : 'text-muted-foreground hover:bg-muted hover:text-foreground', 'group flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors')} data-id="element-236">
                <item.icon className={cn(isActive ? 'text-primary' : 'text-muted-foreground group-hover:text-foreground', 'mr-3 h-5 w-5 flex-shrink-0 transition-colors')} aria-hidden="true" data-id="element-237" />
                {item.name}
              </Link>;
        })}
        </nav>

        <div className="mt-auto pt-6 space-y-1" data-id="element-238">
          <Link to="/app/configuracoes" onClick={onNavigate} className={cn(location.pathname === '/app/configuracoes' ? 'bg-primary/10 text-primary font-medium' : 'text-muted-foreground hover:bg-muted hover:text-foreground', 'group flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors')} data-id="element-239">
            <Settings className="mr-3 h-5 w-5 flex-shrink-0 text-muted-foreground group-hover:text-foreground" data-id="element-240" />
            Configurações
          </Link>
          <Link to="/login" onClick={onNavigate} className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-muted-foreground hover:bg-destructive/10 hover:text-destructive transition-colors" data-id="element-241">
            <LogOut className="mr-3 h-5 w-5 flex-shrink-0 text-muted-foreground group-hover:text-destructive" data-id="element-242" />
            Sair
          </Link>
        </div>
      </div>
    </div>;
}